import styled from 'styled-components'
import Button from 'react-bootstrap/Button'
import { colors } from '../../../const/theme'
import Figure from 'react-bootstrap/esm/Figure'
import Card from '../../../components/CardWrapper'

export const DropdownWrapper = styled.div`
  margin: auto 12px;
  width: 25%;
  @media (max-width: 415px) {
    width: 100%;
    margin: 8px;
  }
`

export const Icon = styled(Button)`
  border-color: ${colors.white};
  color: ${colors.gray};
  text-transform: capitalize;
  &:hover,
  &:focus {
    border-color: ${colors.white};
    background: ${colors.white};
    color: ${colors.black};
  }
  max-width: 40px;
`

export const TableRow = styled.tr`
  vertical-align: baseline;
`

export const UserActionWrapper = styled.div`
  text-align: center;
`

export const UserLogo = styled(Figure)`
  border: 1px solid ${({ theme }) => theme.border};
  padding: 8px;
  margin: auto;
`

export const Details = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: row;
  width: 80%;
  @media (max-width: 415px) {
    flex-direction: column;
    width: 100%;
  }
  justify-content: space-around;
`

export const ColumnWrapper = styled.div`
  width: 35%;
  @media (max-width: 415px) {
    width: 100%;
  }
`

export const CardWrapper = styled(Card)`
  width: 45%;
  padding: 0 32px 16px;
  @media (max-width: 415px) {
    width: 100%;
    margin-bottom: 16px;
  }
`

export const DatePickerWrapper = styled.div`
  width: 30%;
  height: auto;
`

export const DisplayAdminCount = styled.div`
  color: rgb(73, 80, 87);
  font-size: 0.9rem;
  font-weight: bold;
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  margin: 10px 10px;
`
export const FormBackWrapper = styled.div`
  background-color: white !important;
  border-radius: 10px;
  margin-top: 20px;
  padding-bottom: 20px;
`